import templateCategories from './categories';
import menu from './menu';

export const fetchCategoriesTemplate = () => templateCategories;

export const fetchDataMenuTemplate = () => menu.map((item) => ({ ...item, amount: 0 }));

export async function fetchData(url, method = 'GET', data = null, headers = {}) {
    if (!url) {
        throw new Error('URL is required');
    }

    const effectiveHeaders = headers || { 'Content-Type': 'application/json' };

    const options = {
        method,
        headers: effectiveHeaders,
        ...(data && { body: JSON.stringify(data) }),
    };

    try {
        const response = await fetch(url, options);
        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }
        return await response.json();
    } catch (error) {
        if (error instanceof TypeError) {
            // Сетевая ошибка: отсутствие соединения или недоступность сервера
            const newError = new Error("Немає з'єднання з інтернетом. Перевірте ваше з'єднання і спробуйте ще раз.");
            throw newError;
        } else {
            throw error;
        }
    }
}

export async function getIPFromAmazon() {
    try {
        const response = await fetch('https://checkip.amazonaws.com/');
        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }
        const ip = await response.text();
        alert(ip);
    } catch (error) {
        console.error('IP fetch error:', error);
    }
}
